import React, { useEffect } from "react";
import { useQuery } from "react-query";
import { useDispatch } from "react-redux";
import { setShellConfig } from "../../redux/styleConfig/styleSlice";

interface AppStyleProps {
  children: React.ReactNode;
}

const AppStyle = ({ children }: AppStyleProps) => {
  const { data: jsonFile } = useQuery(
    "shellConfig",
    async () => {
      const response = await fetch(`${process.env.REACT_APP_SHELL_CONFIG}`);
      return response.json();
    },
    {
      staleTime: 1000 * 60 * 30,
      cacheTime: 1000 * 60 * 60,
      refetchOnWindowFocus: false,
    }
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (jsonFile) {
      dispatch(setShellConfig(jsonFile));
    }
  }, [jsonFile, dispatch]);
  const css = `
.SuccessDefault{
 background: ${jsonFile?.mainColor} !important;
}
.defualtColor{
 color: ${jsonFile?.defualtColor} !important;
}
.defualtColor_100{
 color: ${jsonFile?.defualtColor_100} !important;
}
.defualtColor_200{
 color: ${jsonFile?.defualtColor_200} !important;
}
.secondColor-100{
 color: ${jsonFile?.secondColor_100} !important;
}
.secondColor_200{
 color: ${jsonFile?.secondColor_200} !important;
}
.secondColor_300{
 color: ${jsonFile?.secondColor_300} !important;
}
.secondColor_400{
 color: ${jsonFile?.secondColor_400} !important;
}
.secondColor_500{
 color: ${jsonFile?.secondColor_500} !important;
}
.defualtColor-BG{
 background: ${jsonFile?.defualtColor} !important;
}
.defualtColor_100_BG{
 background: ${jsonFile?.defualtColor_100} !important;
}
.defualtColor_200_BG{
 background: ${jsonFile?.defualtColor_200} !important;
}
.secondColor-100-BG{
 background: ${jsonFile?.secondColor_100} !important;
}
.secondColor_200_BG{
 background: ${jsonFile?.secondColor_200} !important;
}
.secondColor_300_BG{
 background: ${jsonFile?.secondColor_300} !important;
}
.secondColor_400_BG{
 background: ${jsonFile?.secondColor_400} !important;
}
.secondColor_500_BG{
 background: ${jsonFile?.secondColor_500} !important;
}

.disabledBtn{
 background: ${jsonFile?.defualtColor_200} !important;
}
.SuccessDefaultFont {
 color: ${jsonFile?.mainColor} !important;
}
.colorUserProfile{
 color: ${jsonFile?.secondColor} !important;
}
.iconProfileBorder{
 border: 2px solid ${jsonFile?.mainColor};
}
.personIcon{
 color: ${jsonFile?.mainColor} !important;
}

.colorBorderSvgWallet{
 border: 2px solid ${jsonFile?.mainColor};
}

.colorTitleWallet{
 color: ${jsonFile?.mainColor} !important;
}

.borderWalletBtnBottom{
 background: ${jsonFile?.mainColor} !important;
}
.deactivatedButton {
 background-color: ${jsonFile?.secondColor} !important;
}

.activatedButton {
 background-color: ${jsonFile?.mainColor} !important;
 min-width: 50px !important;
}

.place-image>div>div>div {
 background-color: ${jsonFile?.mainColor} !important;
}

.fileuploader-modal-container>div>div>div>p {
 background-color: ${jsonFile?.mainColor} !important;
}
.fileuploader-modal-container>div>div>div>div>div>div>p {
 background-color: ${jsonFile?.mainColor} !important;
}

.Mui-selected {
background: ${jsonFile?.mainColor} !important;
color: #fff !important;
}
.css-fvc8ir-MuiBadge-badge {
background-color: ${jsonFile?.mainColor} !important;
}
.css-1o4n2ye {
background-color: ${jsonFile?.mainColor} !important;
}

`;
  return (
    <>
      <style>{css}</style>
      {children}
    </>
  );
};

export default AppStyle;
